// client/src/components/PrivacyText.js

const privacyText = `
LuckyLogic.ai (a service of LottoLogic LLC) – Privacy Policy
Effective Date: June 1st, 2025
Version: 1.1

LuckyLogic.ai, operated by LottoLogic LLC ("LuckyLogic.ai", "LuckyLogic", "we", "us", or "our"), values your privacy. This Privacy Policy describes how we collect, use, and protect your personal information when you use our website and services. By using LuckyLogic.ai, you agree to the terms of this policy.

1. Information We Collect
When you sign up for LuckyLogic.ai, we collect only the information necessary to deliver our services:

• First and Last Name  
• Email Address  
• Phone Number  
• ZIP Code (used to determine City and State)  
• Communication Preferences (email, text, or both)  
• Subscription Plan Details  

We do not collect or store your payment card information. All payments are securely processed through Stripe, a trusted third-party payment processor.

2. How We Use Your Information
We use the information you provide to:

• Send you Powerball or Mega Millions number sets before each drawing  
• Manage and fulfill your subscription  
• Communicate important service updates  
• Personalize your experience  
• Comply with legal obligations  

We do not use your data for advertising or tracking purposes, and we never sell or rent your personal information to third parties.

3. Communications
By signing up, you consent to receive email and/or SMS messages from us. These communications are used to deliver your number sets and provide important service notices.

We use:  
• SendGrid to send emails  
• Twilio to send text messages  

You may update your communication preferences at any time via your account settings.

4. Payment Information
We partner with Stripe for payment processing. Stripe securely handles all billing and payment data. LuckyLogic.ai does not store, transmit, or have access to your credit card or bank information.

For more information on how Stripe handles your data, see https://stripe.com/privacy.

5. Data Sharing and Disclosure
We do not sell, rent, or share your personal data with any third parties for marketing purposes.  

We only share data with service providers (e.g., Stripe, SendGrid, Twilio) as needed to provide our services. These providers are bound by confidentiality and data protection obligations.  

We may disclose your information if required by law (e.g., court order, legal process).

6. Data Security
We implement appropriate technical and organizational measures to protect your information from unauthorized access, loss, misuse, or alteration. Your data is stored securely, with encryption and restricted access policies in place.

7. Your Rights and Choices
You have the right to:  

• View and update your personal information  
• Change your communication preferences  
• Deactivate or close your account  
• Request deletion of your data (subject to legal or business recordkeeping obligations)  

To make any of these changes, please contact us at support@luckylogic.ai.

8. Data Retention
We retain your data for as long as your account is active or as needed to provide services, comply with laws, resolve disputes, and enforce agreements. You may request data deletion at any time.

9. Children's Privacy
LuckyLogic.ai is not intended for use by individuals under the age of 18. We do not knowingly collect or store personal data from minors. If you believe a minor has used our service, please contact us and we will promptly delete their data.

10. Changes to This Policy
We may update this Privacy Policy from time to time. If changes are made, we will post the revised version on this page and update the "Effective Date" above. Continued use of our service after changes are posted constitutes your acceptance of the revised policy.

11. Contact Information
LuckyLogic.ai (operated by LottoLogic LLC)  
307 SW 2nd Street  
Bentonville, Arkansas 72712  
Email: support@luckylogic.ai
`;

export default privacyText;
